import React, { useState, useEffect } from 'react'
import { SortUpIcon } from 'Assets/Images/icons/SortUpIcon'
import SelectV2 from 'Components/Form/SelectV2'
import { IconButton, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { DESIGN_STATUS } from './hooks/useDesignManagement'
import {
  DocumentNames,
  DMDocumentLabels,
  ADMDocumentLabels,
} from '../../shared/constants'
import { fetchAllClientsByChunks } from '../Campaigns/gql'

const FilterSection = ({
  activeFilters,
  onFilterChange,
  items,
  classes,
  isAdmin = false,
}) => {
  const [clients, setClients] = useState([])
  const [loadingClients, setLoadingClients] = useState(false)

  // Fetch clients for admin users
  useEffect(() => {
    if (isAdmin) {
      fetchClients()
    }
  }, [isAdmin])

  const fetchClients = async () => {
    setLoadingClients(true)
    try {
      // Use existing platform logic that handles pagination automatically
      const { clients } = await fetchAllClientsByChunks({
        chunkSize: 100, // Respects API limit while fetching all clients
      })

      const clientOptions = [
        { label: 'All Clients', value: 'All' },
        ...clients.map(client => ({
          label: client.name,
          value: client.id,
        })),
      ]
      setClients(clientOptions)
    } catch (error) {
      console.error('Failed to fetch clients:', error)
    } finally {
      setLoadingClients(false)
    }
  }
  // Define all possible formats based on the actual FORMATS object from campaign builder
  const allPossibleFormats = [
    { label: 'All', value: 'All' },
    ...Object.entries({
      ...DocumentNames,
      ...DMDocumentLabels,
      ...ADMDocumentLabels,
    }).map(([key, value]) => ({
      label: value,
      value: key,
    })),
  ]

  const uniqueStatuses = [
    { label: 'All', value: 'All' },
    { label: 'Active', value: String(DESIGN_STATUS.ACTIVE) },
    { label: 'Archived', value: String(DESIGN_STATUS.ARCHIVED) },
  ]

  const sortByOptions = [
    { label: 'Design name', value: 'designName' },
    { label: 'Date created', value: 'dateCreated' },
    { label: 'Designer', value: 'designer' },
    { label: 'Status', value: 'status' },
    { label: 'Format', value: 'format' },
  ]

  const onSearchChange = e => {
    try {
      const value = e.target.value
      onFilterChange('search', value)
    } catch (error) {
      console.error(error)
    }
  }
  return (
    <section
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '16px',
        alignItems: 'flex-end',
        marginTop: '20px',
        width: '100%',
      }}
    >
      <div style={{ flex: '1 1 180px', minWidth: '180px', color: '#6b7280' }}>
        <label
          style={{
            display: 'flex',
            color: '7F8FA4',
            lineHeight: '20px',
            width: 'max-content',
            fontWeight: '400',
          }}
          cypress_id={'searchTitle'}
        >
          Search your workflow
        </label>
        <div
          style={{
            marginTop: '4px',
            width: '100%',
            fontSize: '16px',
          }}
        >
          <div
            style={{
              display: 'flex',
              gap: '6px',
              padding: '6px',
              backgroundColor: '#ffffff',
              borderRadius: '8px',
              border: '1px solid #E2E2FC',
            }}
          >
            <img
              src="https://cdn.builder.io/api/v1/image/assets/9027e467a3654d80815291ebf67cf00c/63120cea2e741e999e5f02e4789b24202f30085b?placeholderIfAbsent=true"
              alt="Search icon"
              style={{
                objectFit: 'contain',
                flexShrink: 0,
                width: '24px',
                aspectRatio: 1,
              }}
            />
            <input
              type="text"
              placeholder="Search..."
              style={{
                flexGrow: 1,
                flexShrink: 1,
                color: '#6b7280',
                width: '163px',
                backgroundColor: 'transparent',
                border: 'none',
                outline: 'none',
                fontSize: '16px',
              }}
              value={activeFilters.search}
              onChange={onSearchChange}
            />
          </div>
        </div>
      </div>
      <SelectV2
        label="Status"
        options={uniqueStatuses}
        value={activeFilters.status}
        cypress_id={'StatusSelect'}
        onChange={(e, index, value) => onFilterChange('status', value)}
        style={{ flex: 1 }}
      />
      <SelectV2
        label="Format"
        options={allPossibleFormats}
        value={activeFilters.format}
        cypress_id={'FormatSelect'}
        onChange={(e, index, value) => onFilterChange('format', value)}
        style={{ flex: 1 }}
      />
      {isAdmin && (
        <div style={{ flex: 1 }}>
          <Autocomplete
            options={clients}
            getOptionLabel={option => option.label || ''}
            value={
              clients.find(
                c => c.value === (activeFilters.clientId || 'All'),
              ) || null
            }
            onChange={(e, option) =>
              onFilterChange(
                'clientId',
                option && option.value !== 'All' ? option.value : null,
              )
            }
            renderInput={params => (
              <TextField
                {...params}
                label="Client"
                variant="outlined"
                size="small"
                data-cypress_id="ClientSelect"
              />
            )}
            disabled={loadingClients}
            disableClearable={false}
            autoHighlight
            openOnFocus
            size="small"
          />
        </div>
      )}
      <SelectV2
        label="Sort by"
        options={sortByOptions}
        value={activeFilters.sortBy}
        cypress_id={'SortBySelect'}
        onChange={(e, index, value) => onFilterChange('sortBy', value)}
        style={{ flex: 1 }}
      />
      <IconButton
        onClick={() =>
          onFilterChange(
            'sortDirection',
            activeFilters.sortDirection === 'asc' ? 'desc' : 'asc',
          )
        }
      >
        <SortUpIcon
          style={{
            transform:
              activeFilters.sortDirection === 'desc' ? 'rotate(180deg)' : '',
          }}
          cypress_id={'sortIcon'}
        />
      </IconButton>
    </section>
  )
}

export default FilterSection
